import { PropsWithChildren } from "react";
import { Button, Text } from "@chakra-ui/react";
import { useFilterModalContext } from "../FiltersModal/FiltersModal";
import { ChevronForward } from "icons";

type ModalFilterProps = PropsWithChildren & {
  isSet: boolean;
  name: string;
  buttonName: string;
};

const ModalFilter = ({
  children,
  isSet,
  name,
  buttonName,
}: ModalFilterProps) => {
  const { isActive, onOpen } = useFilterModalContext();

  if (isActive) {
    return (
      <>
        <Text m={4} fontSize="sm" fontWeight="semibold">
          {name}
        </Text>
        {children}
      </>
    );
  }

  return (
    <Button
      onClick={onOpen}
      colorScheme={isSet ? "navy" : "grey"}
      variant="ghost"
      size="sm"
      justifyContent="space-between"
      px={4}
      height={10}
      rightIcon={<ChevronForward color="gray.700" />}
      borderBottomWidth="1px"
      borderBottomColor="gray.100"
    >
      {buttonName}
    </Button>
  );
};

export default ModalFilter;
